
import React, { Component } from 'react';
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import ReactPaginate from 'react-paginate';
import Tooltip from 'react-tooltip';
import { MdDelete, MdModeEdit, MdOutlineCheck, MdOutlineClose, MdSearch } from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { FaListAlt } from 'react-icons/fa';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill } from "react-icons/bs";
import { Button } from "react-bootstrap";
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import ModalQuestao from './ModalQuestao';
import ModalQuestoesCsv from './ModalQuestoesCsv';
import StatusBadge, { getApprovalStatus, getQuestionStatus } from '../ReusableComponents/StatusBadge';
import { PreferencesContext } from '../../contexts/PreferencesContext';

class Questoes extends Component {
  static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: false,
      questoes: [],
      pagination: {
        page: 1,
        last_page: 1
      },
      categoria: { name: '' },
      msgErro: '',
      show_warning: false,
      show_erro: false,
      unidade_to_delete: '',
      search: '',
      loading_search: true,
      showModal: false,
      questaoSelect: null,
      questaoStatus: {},
      show_warning_anular: false,
      showModalCsv: false
    };
  }






  componentDidMount() {
    console.log('Usuário:', this.props.user); // Fazendo o console.log do "user" aqui
    this.get_questoes(this.state.pagination.page);
  }

  get_questoes(page, search = '', busca = true) {
    if (busca == true) {
      if (this.state.loading_search == false) {
        this.setState({ loading_search: true });
      }
    } else
    if (this.state.loading_screen === false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_questoes/${this.props.match.params.id}?page=${page}&search=${search}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });
        } else
        {
          this.setState({ loading_search: false, categoria: resp.categoria, questoes: resp.questoes, loading_screen: false, pagination: resp.pagination });
        }
      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);
      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }


  delete_questao(id) {

    fetch(`${URL}api/faculdade/delete_questao/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ msgErro: erro, show_warning: false, show_erro: true });
        } else
        {
          this.setState({ show_warning: false });
          this.get_questoes(this.state.pagination.page, this.state.search);
        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
    });
  }


  anular_questao(id) {

    fetch(`${URL}api/faculdade/status/${id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ msgErro: erro, show_warning_anular: false, show_erro: true });
        } else
        {
          this.setState({ show_warning_anular: false });
          this.get_questoes(this.state.pagination.page, this.state.search);
        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
    });
  }






  render() {
    const { t } = this.context || { t: (key) => key };

    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={this.state.path} />}
                <ModalQuestao showModal={this.state.showModal} setShowModal={(e) => this.setState({ showModal: e })} questao={this.state.questaoSelect} />

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">
                        <div style={{ float: 'right' }}>
                            <DefaultButton
                  bg="secondary"
                  text={t('action_back')}
                  icon={<RiArrowGoBackLine />}
                  to={`/disciplinas`} />

                        </div>
                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{t('title_question_list')}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>{t('desc_subject_questions')} {this.state.categoria.name}</p>
                            <br />
                            <br />

                            <div className="row">

                                <div className="col-12">
                                <ModalQuestoesCsv onFinish={() => {






                    // setLoadingcandidatos(true);
                    // Getcandidatos(1, search_oficial);
                  }} showModal={this.state.showModalCsv} setShowModal={(e) => this.setState({ showModalCsv: e })} categoria_id={this.state.categoria.id} categoria_name={this.state.categoria.name} />


                                    {/* <hr /> */}
                                    {this.state.loading_screen == false && <div>

                                        {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                                        {/* <br /> */}

                                        <div className="questions-list-toolbar mb-4">
                                            <div className="questions-search-shell">
                                                <Search hide_class className="questions-search" placeholder={t('placeholder_search_question')} ValueChange={(value) => {clearTimeout(this.pesquisarTimeout);this.pesquisarTimeout = setTimeout(() => {let page = { ...this.state.pagination };page.current_page = 1;this.setState({ pagination: page, search: value, loading_search: true });this.get_questoes(1, value);
                              }, 500);
                          }} />
                                            </div>

                                            <div className="questions-actions">
                                                <Link to={{
                          pathname: "/questoes/register/" + this.state.categoria.id
                          // state: {
                          //     course_id: id
                          // }
                        }} style={{ textDecoration: "none" }}>
                                                    <Button variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t('action_add_question')}</p></Button>
                                                </Link>
                                                <Button
                          disabled={this.state.loading_screen}
                          onClick={() => {
                            // setShowModal(true);
                            this.setState({ showModalCsv: true });
                          }} variant="success" className="flex align-center jcc"><FaListAlt style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t('action_add_questions_docx')}</p></Button>
                                            </div>
                                        </div>

                                        <div className="table-modern-card">
                                                <table id="tech-companies-1" className="table table-striped">
                                                    <thead>
                                                        <tr>

                                                            <th>{t('label_statement')}</th>
                                                            <th>{t('label_correct_alternative')}</th>
                                                            <th>{t('label_question_type')}</th>
                                                            <th>{t('label_status')}</th>
                                                            <th>{t('label_auditor_status')}</th>
                                                            <th>{t('label_registered_by')}</th>
                                                            <th data-priority="3">{t('label_actions')}</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.loading_search == false && this.state.questoes.map((item, id) =>

                            <tr key={id}>
                                                                <td style={{ textAlign: 'justify', textOverflow: 'ellipsis' }}>{item.text_questao}</td>
                                                                {item.type_questao == 'simples' && <td>{item.correta})</td>}
                                                                {(item.type_questao == 'conjunto' || item.type_questao == 'dissertativa') && <td>-</td>}
                                                                <td>{item.type_questao == 'conjunto' ? 'Conjunto de questões - ' + item.questoes.length + (item.questoes.length == 1 ? ' questão' : ' questões') :
                                item.type_questao == 'simples' ? this.context.t("legacy_questao_unica") : 'Questão dissertativa'}</td>
                                                                 <td><StatusBadge {...getQuestionStatus(item.status)} /></td>
                                                                <td><StatusBadge {...getApprovalStatus(item.statusAprovacao)} /></td>

                                                                <td>{item.user.name}</td>

                                                                {/* <td>Questão {id + 1}</td> */}
                                                                <td>
  <div className="actions-group">

                                                                        <span
                                  onClick={() => {
                                    this.setState({ questaoSelect: { ...item }, showModal: true });
                                  }}
                                  className="inline-flex align-center jcc bg-warning icon"
                                  style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                  title={this.context.t("ui_gerenciar_questao_71268f08")}>

                                                                            <BsFillEyeFill size={17} color="white" />
                                                                        </span>

                                                                        {this.state.categoria.name != 'Simulado Teste' && <span
                                  onClick={(e) => {
                                    this.questao_id = item.id;
                                    this.setState({ show_warning_anular: true, questaoStatus: item });
                                  }}
                                  className="inline-flex align-center jcc bg-primary icon"
                                  style={{ width: "2em", height: "2em", borderRadius: "7px", marginLeft: "2px" }}
                                  title={item.status == 'A' ? 'desanular' : 'anular' + " questão"}>

                                                                        {item.status == 'A' ? <MdOutlineCheck size={17} color="white" /> : <MdOutlineClose size={17} color="white" />}
                                                                    </span>}

                                                                    {this.state.categoria.name != 'Simulado Teste' && (item.andamento == false || this.props.user?.empresa?.online_proccess == false) && <Link to={`/questoes/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                                        <span
                                    className="inline-flex align-center jcc bg-info icon"
                                    style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                    data-toggle="tooltip"
                                    title={this.context.t("legacy_editar_questao")}>

                                                                            <MdModeEdit color="white" size={17} />
                                                                        </span>
                                                                    </Link>}
                                                                    {this.state.categoria.name != 'Simulado Teste' && (item.andamento == false || this.props.user?.empresa?.online_proccess == false) && <span
                                  onClick={(e) => {
                                    this.questao_id = item.id;
                                    this.setState({ show_warning: true });
                                  }}
                                  className="inline-flex align-center jcc bg-danger icon"
                                  style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                  title={this.context.t("ui_deletar_questao_6f8e24a2")}>

                                                                        <MdDelete size={17} color="white" />
                                                                    </span>}

  </div>
</td>

                                                            </tr>
                            )}

                                                    </tbody>
                                                </table>

                                        </div>
                                        {this.state.loading_search == true &&

                    <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center table-state-spacing">
                                                <CircularProgress />
                                            </div></div>

                    }
                                        {this.state.loading_search == false && this.state.questoes.length == 0 && <div className="row">
                                            <div className="col-12 table-state-spacing">
                                                <TableEmptyState title={this.context.t("ui_nenhuma_questao_cadastrada_2b696d49")} icon="❓" />

                                            </div>
                                        </div>}

                                        <Pagination
                      className={this.state.pagination.last_page == 1 ? "hide" : ""}
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      count={this.state.pagination.last_page}
                      value={this.state.pagination.current_page}
                      onChange={(_, value) => {
                        console.log(_, value);
                        let page = { ...this.state.pagination };
                        page.current_page = value;
                        this.setState({ pagination: page });
                        this.get_questoes(value, this.state.search);
                      }} />


                                        {/* {this.state.andamento == true && <AvaliacaoAndamento get_processo={this.get_processo.bind(this)} {...this.props} />} */}

                                    </div>}

                                    {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                        {/* <div className="spinner-border text-primary" role="status"  >
                        </div> */}
                                        <CircularProgress />
                                    </div></div>}

                                    <SweetAlert
                    warning
                    title={this.context.t("legacy_atencao")}
                    onConfirm={() => {
                      this.setState({ show_warning: false, loading_search: true });
                      this.delete_questao(this.questao_id);
                      // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                      this.setState({ show_warning: false });
                    }}
                    show={this.state.show_warning}
                    confirmBtnText={this.context.t("legacy_sim_desejo_apagar")}
                    cancelBtnText={this.context.t("legacy_cancelar")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}>{this.context.t("ui_ao_deletar_esta_questao_ela_nao_estara_mais_dispon_a09d435b")}


                  </SweetAlert>

                                    <SweetAlert
                    warning
                    title={this.context.t("legacy_atencao")}
                    onConfirm={() => {
                      this.setState({ show_warning_anular: false, loading_search: true });
                      this.anular_questao(this.questao_id);
                      // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                      this.setState({ show_warning_anular: false });
                    }}
                    show={this.state.show_warning_anular}
                    confirmBtnText={'Sim, desejo ' + (this.state.questaoStatus.status == 'A' ? 'desanular' : 'anular')}
                    cancelBtnText={this.context.t("legacy_cancelar")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}>{this.context.t("ui_deseja_marcar_essa_questao_como_b8074843")}

                    {this.state.questaoStatus.status == 'A' ? 'não anulada' : 'anulada'}?
                                    </SweetAlert>


                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  user: state.AppReducer.user,
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(Questoes);
